export function moveElement(elements, widgetId, targetContainerId, targetColIdx, targetIndex) {
  let dragged = null;
  const removeFromRoot = (els) => {
    const idx = els.findIndex(e => e.id === widgetId);
    if (idx !== -1) { dragged = els[idx]; return [...els.slice(0, idx), ...els.slice(idx + 1)]; }
    return els.map(el => {
      if (el.type === 'container' && el.columns) {
        const newCols = el.columns.map(col => {
          const ci = col.findIndex(w => w.id === widgetId);
          if (ci !== -1) { dragged = col[ci]; return [...col.slice(0, ci), ...col.slice(ci + 1)]; }
          return col;
        });
        return { ...el, columns: newCols };
      }
      return el;
    });
  };
  let next = removeFromRoot(elements);
  if (!dragged) return elements;
  
  if (targetContainerId === null) {
    const safeIdx = Math.min(targetIndex, next.length);
    next = [...next.slice(0, safeIdx), dragged, ...next.slice(safeIdx)];
  } else {
    next = next.map(el => {
      if (el.id === targetContainerId) {
        const col = [...(el.columns[targetColIdx] || [])];
        const safeIdx = Math.min(targetIndex, col.length);
        col.splice(safeIdx, 0, dragged);
        const newCols = el.columns.map((c, i) => i === targetColIdx ? col : c);
        return { ...el, columns: newCols };
      }
      return el;
    });
  }
  return next;
}

export const buildNewElement = (type) => {
  const baseStyles = { marginTop: 0, marginBottom: 0 };
  let specificStyles = {}, initialContent = '';
  
  if (type === 'button') { specificStyles = { text: 'Get Started', bgColor: '#2dd4bf', textColor: '#ffffff', link: '', linkType: 'url', shadow: 'none', glow: false, borderRadius: 12 }; initialContent = 'Get Started'; }
  else if (type === 'heading') { specificStyles = { fontSize: 48, fontWeight: '900', color: '#111827', textAlign: 'center' }; initialContent = 'Click to Edit'; }
  else if (type === 'text') { specificStyles = { fontSize: 24, fontWeight: '400', color: '#4b5563', textAlign: 'left' }; initialContent = 'Click to edit this text block.'; }
  else if (type === 'image') { specificStyles = { imageUrl: '', altText: 'Image', objectFit: 'cover', width: 100, height: 'auto', maxWidth: '100%' }; }
  else if (type === 'spacer') { specificStyles = { height: 50 }; }
  else if (type === 'container') { specificStyles = { backgroundType: 'color', backgroundColor: '#ffffff', backgroundImage: '', paddingTop: 48, paddingBottom: 48, overlayOpacity: 0, overlayColor: '#000000' }; }
  else if (type === 'products') { specificStyles = { productCategory: '', columns: 3, mobileColumns: 1, showSaleBadge: true, limit: 6 }; }
  else if (type === 'contact-form') { specificStyles = { destinationEmail: '', buttonText: 'Send Message', buttonBgColor: '#2dd4bf', buttonTextColor: '#ffffff', borderRadius: 12, formBgColor: '#ffffff', inputBgColor: '#f9fafb', textColor: '#111827' }; }
  else if (type === 'reviews') { specificStyles = { columns: 3, showAvatars: true, showSummary: true, cardBgColor: '#ffffff', textColor: '#111827', starColor: '#f59e0b', borderRadius: 16 }; }
  else if (type === 'artist') { specificStyles = { tracks: [], showArtistName: true, artistName: 'Artist Name', cardBgColor: '#ffffff', textColor: '#111827', accentColor: '#5494d4', borderRadius: 16 }; }
  
  return { id: Date.now() + Math.random(), type, content: initialContent, styles: { ...baseStyles, ...specificStyles }, columns: type === 'container' ? [[], []] : null };
};